// Module
var code = `<div class="predicate" ng-if="\$ctrl.predicateDefined">
  <div class="flex-container">
    <div class="transcluded" ng-transclude>
    </div>

    <div class="close" ng-if="!\$ctrl.ngDisabled" ng-click="\$ctrl.close()"></div>
  </div>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/security/role-write-access/predicates/predicate.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;